import openRangeEditor from './open-range-editor';

/*******************************************************************************
TRIGGER THE FILTER RANGE UI
Handles a click on the filter range edit button.
*******************************************************************************/

export default function triggerRangeEditor(e) {
    const rangeEditorID = $(e.currentTarget).parents('.filter-range').attr('id');
    openRangeEditor(rangeEditorID);
}
